import React, {useState} from 'react';
import styled from "styled-components";

const StyledBadge = styled.span`
  display: inline-block;
  padding: 0.25em 0.4em;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  background-color: ${props => props.color};
  margin-right: 3px
`

function Badge(props) {
  return <StyledBadge color={props.color}>
    {props.children}
  </StyledBadge>
}

export default Badge
